// extracted by mini-css-extract-plugin
export default {"left":"left__Ykvdq"};